import truck from './feed1.png';
import truck2 from './feed1_2.png';
import excavator from './feed2.png';
import excavator2 from './feed2_2.png';
import wheelLoader from './feed3.png';
import wheelLoader2 from './feed3_2.png';
import gravel from './feed4.png';
import type { FeedUnitInfoDataInterface } from './unitInfoData';
import type { UnitInfoFeedInterface } from 'store/units/types';

export const feedTypes = [
  {
    id: 1,
    displayName: 'Truck',
    image: truck,
    image2: truck2,
  },
  {
    id: 2,
    displayName: 'Excavator',
    image: excavator,
    image2: excavator2,
  },
  {
    id: 3,
    displayName: 'Wheel Loader',
    image: wheelLoader,
    image2: wheelLoader2,
  },
  {
    id: 4,
    displayName: 'Generic Feed',
    image: gravel,
    image2: gravel,
  },
];

export enum RADIO_MODE {
  DENSITY = 'DENSITY',
  GRAVITY = 'GRAVITY',
}

export const getDefaultData = (
  unitInfoData: FeedUnitInfoDataInterface,
  variantId?: number,
): UnitInfoFeedInterface => {
  return {
    moistureUI: 0,
    psd: [],
    size: [],
    radioMode: RADIO_MODE.GRAVITY,
    feedImg: variantId ?? feedTypes[0].id,
    inputFlow: {
      psd: unitInfoData.psdCurves[0].psd,
      size: unitInfoData.psdCurves[0].size,
      maxStoneSize: unitInfoData.psdCurves[0].maxStoneSize,
      moisture: 0,
      workIndex: 16,
      bulkDensity: 1.6,
      abrasionIndex: 0.46,
      specificGravity: 2.65,
      totalMass: 100,
      clay: 0,
      materialId: unitInfoData.predefinedMaterials[0].id,
      materialName: unitInfoData.predefinedMaterials[0].name,
      wetScreen: false,
      psdId: unitInfoData.psdCurves[0].id,
      psdName: unitInfoData.psdCurves[0].name,
    },
    display: {
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
      displayUnitName: true,
      displayMaterialName: true,
      displayFeedRate: false,
      displayBulkDensity: false,
      displaySpecificGravity: true,
      displayMoisture: true,
      displayClay: false,
      displayWorkIndex: true,
      displayCompensatedWorkIndex: false,
      displayAbrasionIndex: false,
      displayPSDFeedCurveName: true,
      displayPsdList: true,
      displayPsdGraph: false,
    },
  };
};

export const calcCompensatedWorkIndex = (
  workIndex: number | undefined,
  specificGravity: number | undefined,
): number | undefined => {
  if (!workIndex || !specificGravity) return undefined;
  return parseFloat(((workIndex * specificGravity) / 2.65).toFixed(2));
};

import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';

export class FeedConfig extends BaseUnitConfig {
  static getDefaultData(params?: UnitConfigParams): UnitInfoFeedInterface {
    const data = params?.data ?? {};
    const variantId = params?.variantId;
    return getDefaultData(
      data as unknown as FeedUnitInfoDataInterface,
      variantId,
    );
  }

  static getNumberOfPorts(): number {
    return 1;
  }
}

export const feedConfig = new FeedConfig();
